import { render } from "./EndUserClaimRow.vue?vue&type=template&id=2fc5c501&ts=true"
import script from "./EndUserClaimRow.vue?vue&type=script&lang=ts"
export * from "./EndUserClaimRow.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__